import React from "react";
import BlurModal from "../../CommonComponents/BlurModal/BlurModal";
import BlurModalContent from "../../CommonComponents/BlurModal/BlurModalContent";
import BlurModalHeading from "../../CommonComponents/BlurModal/BlurModalHeading";
import HeadLines from "../../CommonComponents/HeadLines";
import { mapIcons } from "../constant";

const MapLegend = ({ show, setShow }) => {
  return (
    <>
      <BlurModal
        className={"blur-modal"}
        show={show}
        onHide={() => setShow(false)}
      >
        <>
          <BlurModalHeading
            className={`
                    padding16
                    `}
            heading={
              <>
                <HeadLines text={"Map Legend"} className="font-weight700 " />
              </>
            }
            showHeadingSepertor={false}
          />
          <BlurModalContent className="text-center padding-left16 padding-right16">
            {mapIcons.map((item, index) => {
              return (
                <div className="d-flex align-items-center padding-bottom16">
                  <img src={item.image} width={26} height={26} alt="" />
                  <HeadLines
                    text={item.label}
                    className="padding-left4 font-weight400 letterSpacing004 colorDark9"
                  />
                </div>
              );
            })}
          </BlurModalContent>
        </>
      </BlurModal>
    </>
  );
};
export default MapLegend;
